import axios from "utils/axiosHelper";

export type DataScopeType = "room" | "hotel";

export interface EntryMeta {
	id: number;
	name: string;
	apiName: string;
	type: string;
	typeMeta: Record<string, any> | null;
	section: string;
	sequence: number;
}

export interface GroupMeta {
	groupId: number;
	groupName: string;
	apiName: string;
	description: string;
	systemType: string;
	sequence: number;
	entries: EntryMeta[];
	topicKey?: string;
	leadEntryId?: number | null;
	gated?: boolean;
}

export interface RoomMeta {
	id: number;
	name: string;
	fullName: string;
}

export interface RoomDataMeta {
	hotelId: number;
	rooms: RoomMeta[];
	scopes: Record<DataScopeType, GroupMeta[]>;
	bedTypeVocabulary: Record<string, string>;
	facilityOrder?: number[];
}

export interface RoomDataValues {
	values: Record<string, string>;
	completion: {
		total: number;
		filled: number;
	};
}

export interface RoomMatrixValues {
	valuesByRoom: Record<string, Record<string, string>>;
	completion: {
		total: number;
		filled: number;
	};
	completionByRoom: Record<string, {
		total: number;
		filled: number;
	}>;
}

export async function getRoomDataMeta(): Promise<RoomDataMeta> {
	const session = (document.getElementById('control_session') as HTMLInputElement)?.value ?? '';
	const thread = (document.getElementById('control_thread') as HTMLInputElement)?.value ?? '';
	const url = `index.php?api=true&controller=SetupRoomDataAmenities&action=ajaxGetMeta&session=${session}&thread=${thread}`;
	const resp = await fetch(url);
	const json = await resp.json();
	return json.data;
}

export async function getRoomDataValues(scopeType: DataScopeType, scopeKey: number): Promise<RoomDataValues> {
	const resp = await axios.get('index.php', {
		params: {
			api: true,
			controller: 'SetupRoomDataAmenities',
			action: 'ajaxGetValues',
			scopeType,
			scopeKey
		}
	});
	return resp.data.data;
}

export async function getRoomMatrixValues(): Promise<RoomMatrixValues> {
	const resp = await axios.get('index.php', {
		params: {
			api: true,
			controller: 'SetupRoomDataAmenities',
			action: 'ajaxGetRoomMatrixValues'
		}
	});
	return resp.data.data;
}

export async function saveRoomDataValues(scopeType: DataScopeType, scopeKey: number, values: Record<string, string>): Promise<any> {
	const resp = await axios.post(
		'index.php?api=true&controller=SetupRoomDataAmenities&action=ajaxSaveValues',
		JSON.stringify({ scopeType, scopeKey, values })
	);
	if (resp.data?.error) {
		throw new Error(resp.data.error);
	}
	return resp.data.data;
}

export async function saveFacilityOrder(order: number[]): Promise<any> {
	const resp = await axios.post(
		'index.php?api=true&controller=SetupRoomDataAmenities&action=ajaxSaveFacilityOrder',
		JSON.stringify({ order })
	);
	if (resp.data?.error) {
		throw new Error(resp.data.error);
	}
	return resp.data.data;
}

export async function saveRoomMatrixValues(valuesByRoom: Record<string, Record<string, string>>): Promise<any> {
	const resp = await axios.post(
		'index.php?api=true&controller=SetupRoomDataAmenities&action=ajaxSaveRoomMatrixValues',
		JSON.stringify({ valuesByRoom })
	);
	if (resp.data?.error) {
		throw new Error(resp.data.error);
	}
	return resp.data.data;
}
